import { render } from "./PositionManagement.vue?vue&type=template&id=a8cd235c&scoped=true"
import script from "./PositionManagement.vue?vue&type=script&lang=js"
export * from "./PositionManagement.vue?vue&type=script&lang=js"

import "@/assets/css/hr-page-shared.css?vue&type=style&index=0&lang=css&external"
import "./PositionManagement.vue?vue&type=style&index=1&id=a8cd235c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8cd235c"]])

export default __exports__